<template>
    <div class="allocation-history-table">
        <div v-if="loading" class="text-center text-muted p-3">
            <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
            Loading allocation history...
        </div>

        <div v-else-if="error" class="alert alert-danger mb-0">
            {{ error }}
        </div>

        <el-table v-else border stripe :data="rows" class="custom-element-table" style="width: 100%">
            <el-table-column label="Date" min-width="145">
                <template slot-scope="scope">{{ scope.row.date || '-' }}</template>
            </el-table-column>
            <el-table-column label="Event" min-width="180">
                <template slot-scope="scope">{{ eventLabel(scope.row.event) }}</template>
            </el-table-column>
            <el-table-column label="Transaction / Invoice" min-width="220">
                <template slot-scope="scope">
                    <template v-if="scope.row.invoice_id">
                        {{ scope.row.invoice_series || scope.row.invoice_id }}
                    </template>
                </template>
            </el-table-column>
            <el-table-column label="Invoice Qty" min-width="110" align="right">
                <template slot-scope="scope">{{ number(scope.row.booking_quantity) }}</template>
            </el-table-column>
            <el-table-column label="Initial Allocation" min-width="135" align="right">
                <template slot-scope="scope">{{ number(scope.row.initial_allocation) }}</template>
            </el-table-column>
            <el-table-column label="Previous Qty" min-width="120" align="right">
                <template slot-scope="scope">{{ number(scope.row.previous_quantity) }}</template>
            </el-table-column>
            <el-table-column label="Final Quantity" min-width="135" align="right">
                <template slot-scope="scope">{{ number(scope.row.updated_quantity) }}</template>
            </el-table-column>
            <el-table-column label="Difference" min-width="100" align="right">
                <template slot-scope="scope">
                    <span :class="changeClass(scope.row.change)">{{ signedNumber(scope.row.change) }}</span>
                </template>
            </el-table-column>
            <template slot="empty">No allocation history.</template>
        </el-table>
    </div>
</template>

<script>
import { ApiHttpService } from '../../services'

export default {
    name: 'AllocationHistoryTable',
    props: {
        series: { type: [String, Number], default: null },
        itemId: { type: [String, Number], default: null },
    },
    data() {
        return { rows: [], loading: false, error: null }
    },
    watch: {
        series: { immediate: true, handler() { this.load() } },
        itemId() {
            if (!this.series) this.load()
        },
    },
    methods: {
        load() {
            if (!this.series && !this.itemId) {
                this.rows = []
                this.$emit('loaded', this.rows)
                return
            }
            this.loading = true
            this.$emit('loading', true)
            this.error = null
            ApiHttpService.getRequest('item-master/allocation-history', {
                item: this.series,
                item_id: this.itemId,
            }).then(response => {
                const payload = response.data || {}
                this.rows = payload.data || []
                this.$emit('loaded', this.rows)
            }).catch(error => {
                this.rows = []
                this.$emit('loaded', this.rows)
                this.error = error.response && error.response.data
                    ? (error.response.data.message || 'Unable to load allocation history.')
                    : 'Unable to load allocation history.'
            }).finally(() => {
                this.loading = false
                this.$emit('loading', false)
            })
        },
        eventLabel(event) {
            return String(event || '').replace(/_/g, ' ').replace(/\b\w/g, character => character.toUpperCase()) || '-'
        },
        number(value) {
            if (value === null || value === undefined || value === '') return '-'
            return Number(value).toLocaleString(undefined, { maximumFractionDigits: 4 })
        },
        signedNumber(value) {
            if (value === null || value === undefined || value === '') return '-'
            const number = Number(value)
            return `${number > 0 ? '+' : ''}${number.toLocaleString(undefined, { maximumFractionDigits: 4 })}`
        },
        changeClass(value) {
            const number = Number(value)
            return number > 0 ? 'text-success' : (number < 0 ? 'text-danger' : 'text-muted')
        },
    },
}
</script>
